import { render, staticRenderFns } from "./ExhibitionPic.vue?vue&type=template&id=3ba7a914&scoped=true"
import script from "./ExhibitionPic.vue?vue&type=script&lang=js"
export * from "./ExhibitionPic.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionPic.vue?vue&type=style&index=0&id=3ba7a914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba7a914",
  null
  
)

export default component.exports